export const PROMOTION_MODEL_COVER_IMAGE_WIDTH = 120;
export const PROMOTION_MODEL_COVER_IMAGE_HEIGHT = 79;
export const PROMOTION_MODEL_COVER_IMAGE_LOGO_HEIGHT = 100;

export const TACTICAL_PROMOTION_ITEM_HEIGHT = 60;
export const TACTICAL_PROMOTION_ITEM_WIDTH = 468;

export const TACTICAL_PROMOTION_ITEM_HEIGHT_MOBILE = 44;
export const TACTICAL_PROMOTION_ITEM_WIDTH_MOBILE = 350;

export const PROMOTION_POSTED_ON_DATE_FORMAT = 'DD-MMM-YYYY';
